import React, { useContext, useRef } from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'primereact/button'
import { DataListPods } from '../../components/DataListPods'
import { GLOBALS } from '../../utils/Globals'
import { PodsService } from '../../services/Pods'
import { Context } from '../../Context'
import { Layout } from '../../components/Layout'

export const PodsList = () => {
  const { isAuth: token } = useContext(Context)
  const dt = useRef(null)
  const columns = [
    {
      field: 'name',
      header: 'POD',
      sortable: true,
      filter: true,
      filterPlaceholder: 'Buscar por Nombre de POD',
    },
    {
      field: 'description',
      header: 'Description',
      sortable: true,
      filter: true,
      filterPlaceholder: 'Buscar por descripcion de POD',
    },
    {
      field: 'status',
      header: 'Estado',
      sortable: true,
      filter: false,
    },
  ]
  
  const customActionButtons = ({ row }) => {
    return (
      <Link to={`${GLOBALS.menu.pods.viewpod}/${row.id}`}>
        <Button
          type="button"
          icon="pi pi-chevron-circle-right"
          className="p-button-primary"
          tooltip="Ver"
        ></Button>
      </Link>
    )
  }
  return (
    <Layout>
      <DataListPods
        ref={dt}
        menuItem={GLOBALS.menu.pods}
        listItems={() => PodsService.getAll(token)}
        bulkDelete={(ids) => PodsService.bulkDelete(ids, token)}
        columns={columns}
        customActionButtons={customActionButtons}
      ></DataListPods>
    </Layout>
  )
}
